import { Grid } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ActionType, RoleType } from 'types'
import GeneralNotes from './GeneralNotes'
import ModelAnswers from './ModelAnswers'
import PrivateNotes from './PrivateNotes'

interface IProps {
  action: ActionType
  assignmentId?: string
  viewOnly: boolean
  userRole: RoleType
  tabText?: string
  tabKey?: string
}

const AssignmentNotes: FC<IProps> = ({ action, assignmentId, userRole, viewOnly, tabText }) => {
  const { t } = useTranslation()

  return ( <>
      <Grid container spacing={4}>
        <Grid item xs={12} lg={4}>
          <ModelAnswers
            action={action}
            assignmentId={assignmentId}
            viewOnly={viewOnly}
            userRole={userRole}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <PrivateNotes
            action={action}
            assignmentId={assignmentId}
            viewOnly={viewOnly}
            userRole={userRole}
          /> 
        </Grid>
        <Grid item xs={12} lg={4}>
          <GeneralNotes
            action={action}
            assignmentId={assignmentId}
            viewOnly={viewOnly}
            userRole={userRole}
          />
        </Grid>
      </Grid>

    </>
  )
}

export default AssignmentNotes
